import React from 'react';
import PropTypes, { oneOf, objectOf, oneOfType, bool, number, string } from 'prop-types';
import styled from 'styled-components';
import style from './style';
import { marginPropType, paddingPropType } from '../../utils/propsTypes';
function oneOfObject(options) {
  return oneOfType([oneOf(options), objectOf(oneOf(options))]);
}
function spacingPropBuild(options) {
  return oneOfType([options, objectOf(options)]);
}
var marginPropBreakpoint = spacingPropBuild(marginPropType);
var paddingPropBreakpoint = spacingPropBuild(paddingPropType);
var boolObject = oneOfType([bool, objectOf(bool)]);
var numberOrStringObject = oneOfType([number, string, objectOf(oneOfType([number, string]))]);
var BoxRenderer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Box__BoxRenderer",
  componentId: "aflvac-0"
})(["", ";"], style);

/**
 * Create Boxes everywhere!
 */
var Box = function Box(props) {
  return /*#__PURE__*/React.createElement(BoxRenderer, props);
};
Box.displayName = 'Box';
Box.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  alignSelf: 'auto',
  border: null,
  borderTop: null,
  borderRight: null,
  borderBottom: null,
  borderLeft: null,
  borderTopLeftRadius: null,
  borderTopRightRadius: null,
  borderBottomLeftRadius: null,
  borderBottomRightRadius: null,
  bottom: false,
  children: null,
  color: 'transparent',
  direction: 'row',
  display: 'block',
  flex: 'shrink',
  height: null,
  justifyContent: 'start',
  left: false,
  margin: 'sp0',
  marginBottom: null,
  marginLeft: null,
  marginRight: null,
  marginTop: null,
  maxHeight: null,
  maxWidth: null,
  minHeight: null,
  minWidth: null,
  overflow: 'visible',
  padding: 'sp0',
  paddingX: null,
  paddingY: null,
  position: 'static',
  right: false,
  shape: 'square',
  top: false,
  width: null,
  wrap: null
};
Box.propTypes = {
  /** oneOf: 'start', 'end', 'center', 'between', 'around', 'stretch' */
  alignContent: oneOfObject(['start', 'end', 'center', 'between', 'around', 'stretch']),
  /** oneOf: 'start', 'end', 'center', 'baseline', 'stretch' */
  alignItems: oneOfObject(['start', 'end', 'center', 'baseline', 'stretch']),
  /** oneOf: 'auto', 'start', 'end', 'center', 'baseline', 'stretch' */
  alignSelf: oneOfObject(['auto', 'start', 'end', 'center', 'baseline', 'stretch']),
  /** bool */
  bottom: boolObject,
  border: numberOrStringObject,
  borderTop: numberOrStringObject,
  borderRight: numberOrStringObject,
  borderBottom: numberOrStringObject,
  borderLeft: numberOrStringObject,
  borderTopLeftRadius: numberOrStringObject,
  borderTopRightRadius: numberOrStringObject,
  borderBottomLeftRadius: numberOrStringObject,
  borderBottomRightRadius: numberOrStringObject,
  children: PropTypes.node,
  /** oneOf: 'white', 'lightGray', 'gray', 'midGray', 'darkGray', 'black', 'lightBlue', 'blue', 'transparent' */
  color: oneOfObject(['white', 'lightGray', 'gray', 'midGray', 'darkGray', 'black', 'lightBlue', 'blue', 'transparent']),
  /** oneOf: 'row', 'column' */
  direction: oneOfObject(['row', 'column']),
  /** oneOf: 'none', 'flex', 'block', 'inlineBlock', 'visuallyHidden' */
  display: oneOfObject(['none', 'flex', 'block', 'inlineBlock', 'visuallyHidden']),
  /** oneOf: 'grow', 'shrink', 'none' */
  flex: oneOfObject(['grow', 'shrink', 'none']),
  /** number or string. Numbers will be suffixed with 'px' */
  height: numberOrStringObject,
  /** oneOf: 'start', 'end', 'center', 'between', 'around' */
  justifyContent: oneOfObject(['start', 'end', 'center', 'between', 'around']),
  /** bool */
  left: boolObject,
  /** oneOf: 'sp0' till 'sp96' or 'auto' */
  margin: marginPropBreakpoint,
  /** oneOf: 'sp0' till 'sp96' or 'auto' */
  marginBottom: marginPropBreakpoint,
  /** oneOf: 'sp0' till 'sp96' or 'auto' */
  marginLeft: marginPropBreakpoint,
  /** oneOf: 'sp0' till 'sp96' or 'auto' */
  marginRight: marginPropBreakpoint,
  /** oneOf: 'sp0' till 'sp96' or 'auto' */
  marginTop: marginPropBreakpoint,
  /** number or string. Numbers will be suffixed with 'px' */
  maxHeight: numberOrStringObject,
  /** number or string. Numbers will be suffixed with 'px' */
  maxWidth: numberOrStringObject,
  /** number or string. Numbers will be suffixed with 'px' */
  minHeight: numberOrStringObject,
  /** number or string. Numbers will be suffixed with 'px' */
  minWidth: numberOrStringObject,
  /** oneOf: 'visible', 'hidden', 'scroll', 'scrollX', 'scrollY', 'auto' */
  overflow: oneOfObject(['visible', 'hidden', 'scroll', 'scrollX', 'scrollY', 'auto']),
  /** oneOf: 'sp0' till 'sp96' */
  padding: paddingPropBreakpoint,
  /** oneOf: 'sp0' till 'sp96' */
  paddingX: paddingPropBreakpoint,
  /** oneOf: 'sp0' till 'sp96' */
  paddingY: paddingPropBreakpoint,
  /** oneOf: 'static', 'absolute', 'relative', 'fixed' */
  position: oneOfObject(['static', 'absolute', 'relative', 'fixed']),
  /** bool */
  right: boolObject,
  /** oneOf: 'square', 'rounded', 'circle', 'roundedTop', 'roundedBottom', 'roundedLeft', 'roundedRight' */
  shape: oneOfObject(['square', 'rounded', 'circle', 'roundedTop', 'roundedBottom', 'roundedLeft', 'roundedRight']),
  /** bool */
  top: boolObject,
  /** number or string. Numbers will be suffixed with 'px' */
  width: numberOrStringObject,
  /** bool */
  wrap: boolObject
};
export default Box;